<template>
    <div class="animated fadeIn">
        <b-row v-if="workspace !== undefined">
            <b-col cols="12" md="6">
                <transition name="slide">
                    <b-card>
                        <b-form>

                            <InputField name="name" :label="this.$t('name')" v-model="workspace.name"
                                @error="fieldError" :rules="{ required: false, length: { min: 2 } }" />

                            <div class="form-actions pull-right">
                                <b-button variant="success" class="mr-2" @click="edit">{{ $t('save') }}</b-button>
                                <b-button variant="danger" @click="remove" v-if="workspaces.length > 1">{{ $t('delete')
                                    }}</b-button>
                            </div>
                        </b-form>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"

export default {
    name: "Edit",
    components: {
        InputField: Input,
        SelectField: Select
    },
    data: function () {
        return {
            errors: []
        }
    },
    computed: {
        workspace() {
            return this.$store.getters.getCurrentProject.workspaces.find(w => {
                return w.uuid == this.$route.params.id
            })
        },

        workspaces() {
            return this.$store.getters.getCurrentProject.workspaces
        }
    },

    methods: {
        remove() {
            this.$bvModal.msgBoxConfirm(this.$t('cantRevert')).then((resp) => {
                if (resp) {
                    this.$http.delete("/v1/project/workspace/" + this.$route.params.id).then(resp => {
                        this.$store.commit("DELETE_WORKSPACE", this.workspace)
                        this.$router.back()

                        this.$bvToast.toast("Workspace removed", {
                            variant: 'danger',
                            title: "Error"
                        })

                    }).catch(error => {
                        if (error.response !== undefined) {
                            if (error.response.status == 500) {
                                this.$serverErrorModal(error)
                                return
                            }

                            this.$bvModal.msgBoxOk(error.response.data.message)
                        }

                    })
                }
            })

        },

        edit() {
            const popup = this.$loadingPopup()
            this.$http.put("/v1/project/workspace/" + this.$route.params.id, this.workspace).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$bvModal.msgBoxOk(error.response.data.message)
                }

            }).finally(() => {
                popup.hide()
            })
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        }
    },
    mounted() {
        if (!this.$isAdmin()) {
            this.$router.back()
        }

        if (this.workspace === null || this.workspace === undefined) {
            this.$router.back()
        }
    }
}
</script>
